import React, { useRef } from 'react';
import Image from 'react-image';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getContentSlug, getGpExclusiveSlug } from 'redux/video/video.slice';
import { Box } from 'components/styled/box';
import styled from 'styled-components';
import { LoaderCircle } from 'components/peek/styles';
import DetailsVideojs from 'components/video/player/TrailerVideojs';
import { Placeholder } from 'components/PlaceholderImage';
import { BiArrowBack } from 'react-icons/bi';
import { gpSubscriptionStatus } from 'redux/subscription/subscription.utils';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import PremiumOverlay from 'components/video/PremiumOverlay';
import { tvodHandler } from 'utils/payment.utils';

export default function PlayGpExclusive() {
  const history = useHistory();
  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  const status = searchParams.get('status');
  let { slug } = useParams();
  // following contentType coming from history state in trailer button in details page
  // const { contentType } = location.state || {};
  const dispatch = useDispatch();
  const { banner, loading } = useSelector((state) => state.video);
  const [gpSubscribe, setGpSubscribe] = React.useState('');
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [trailerEnd, setTrailerEnd] = React.useState(false);
  const playerRef = useRef(null);
  const title = window?.platform_info?.title;
  const gpUser = JSON.parse(localStorage.getItem(`gp_user_${title}`));
  const accessToken = JSON.parse(localStorage.getItem(`access_token_r_${title}`));

  React.useEffect(() => {
    const callGpSubscriptionCheck = async () => {
      const response = await gpSubscriptionStatus(accessToken);
      if (response?.data?.data.status) {
        setGpSubscribe('OK');
      } else if (response?.data?.data.status === false) {
        setGpSubscribe('NOT_OK');
      }
    };

    if (gpUser) {
      callGpSubscriptionCheck();
    }
  }, [gpUser]);

  React.useEffect(() => {
    if (status === 'Failure') {
      setIsModalOpen(true);
    } else {
      dispatch(getGpExclusiveSlug(slug));
    }
  }, [dispatch, slug]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!gpUser) {
        setIsModalOpen(true);
      }
    }, 3000); // Executes after 3 seconds

    return () => clearTimeout(timer);
  }, [gpUser]);

  const videoPath =
    'https://s3.brilliant.com.bd/videos/ccd0b146b49045669544a8bbffcc7820/master.m3u8';
  // const videoPathMp4 =
  //   'https://download.blender.org/peach/bigbuckbunny_movies/BigBuckBunny_320x180.mp4';
  // const poster = `${process.env.REACT_APP_IMAGE_URL}600xauto/${horizontalThumbnails[0]?.path}`;
  const poster = 'https://graphic.rockstreamer.com/images/htuOF5iOisdj9CRzhkLg.jpg';

  const videoJsOptions = {
    autoplay: true,
    playsinline: true,
    crossorigin: 'anonymous',
    controls: true,
    responsive: true,
    vhs: { overrideNative: true },
    hls: { overrideNative: true },
    userActions: {
      hotkeys: {}
    },
    preload: 'auto',
    sources: [
      {
        src: gpUser && gpSubscribe === 'OK' ? banner?.path : banner?.trailerPath,
        type: 'application/x-mpegURL',
        label: 'SD'
      }
      // {
      //   src: videoPathMp4,
      //   type: 'video/mp4'
      // }
    ],
    poster: `${process.env.REACT_APP_IMAGE_URL}400xauto/${banner}`
  };

  const onReady = (player) => {
    playerRef.current = player;
    console.log('Player ready', playerRef.current);
  };

  const onVideoEnd = () => {
    console.log('video Ended');
    if (gpSubscribe === 'NOT_OK') {
      setTrailerEnd(true);
    }
  };

  const handlePlayClick = () => {
    if (gpUser) {
      tvodHandler({ contentId: banner?.id, isTvod: false });
      // if (currentTrack?.tvodexclusive) {
      // window.location.href = 'https://mygp.grameenphone.com/mygp/pack/sms/4431';
      // } else {
      //   callbackTypeTwo(window.location.href, true);
      // }
    }
  };

  const handleGpConfirmation = () => {
    history.push('/');
  };

  // if (loading)
  //   return (
  //     <LoaderWrapper>
  //       <LoaderCircle />
  //     </LoaderWrapper>
  //   );

  return (
    <Wrapper>
      <ConfirmationModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleFunction={handleGpConfirmation}
        text={
          status === 'Failure'
            ? 'Subscription failed'
            : `You must be a MyGP user to view this content.`
        }
      />
      <Box className="img-container">
        {!banner?.trailer || trailerEnd ? (
          <Image
            src={`${process.env.REACT_APP_IMAGE_URL}700xauto/${banner?.horizontalThumbnails[0]?.path}`}
            alt={banner?.title}
            className="banner-img"
            loader={<Placeholder className="banner-img" type="video" />}
            unloader={<Placeholder className="banner-img" type="video" />}
          />
        ) : (
          <div className="video-wrapper">
            <DetailsVideojs videoJsOptions={videoJsOptions} onReady={onReady} onEnd={onVideoEnd} />
            <div className="back-btn">
              <BiArrowBack
                size={25}
                onClick={() => history.push(banner?.type === 'series' ? `/` : `/`)}
              />
              <span>
                Playing: {banner?.title} {gpUser && gpSubscribe === 'NOT_OK' ? 'Trailer' : ''}
              </span>
            </div>
          </div>
        )}

        {gpUser && (!banner?.trailer || trailerEnd) && (
          <PremiumOverlay handlePlayClick={handlePlayClick} />
        )}
      </Box>
    </Wrapper>
  );
}

const LoaderWrapper = styled.div`
  display: grid;
  min-height: calc(100vh - 150px);
  place-items: center;
`;

const Wrapper = styled.div`
  position: relative;

  &:hover {
    .img-container {
      .back-btn {
        opacity: 1;
      }
    }
  }

  .img-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    background-color: #000;
    z-index: 999999;

    @media (max-width: 639px) {
      height: calc(100vh - 80px);

      .back-btn {
        opacity: 1;
      }
    }

    .video-wrapper {
      display: block;
      height: 100%;
      width: 100%;
      position: relative;
      /* overflow: hidden; */
    }
    .back-btn {
      opacity: 0;
      position: absolute;
      z-index: 111;
      top: 3%;
      left: 2%;
      cursor: pointer;
      display: flex;
      gap: 0.5rem;
      align-items: center;
    }
    .skipp-button {
      position: absolute;
      bottom: 15%;
      right: 5%;
      background-color: #fff;
      border-radius: 30px;
      height: 20px;
      width: 50px;
      color: #000 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 111;
      cursor: pointer;
    }
    .banner-img {
      display: block;
      height: 100%;
      width: 100%;
      object-fit: cover;
      filter: blur(4px);
      -webkit-filter: blur(4px);
      border: solid 1px rgba(255, 255, 255, 0.6);
    }

    .play-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 999;

      background-color: transparent;
      transform: translate(-50%, -50%);
    }
  }
`;
